<template>
  <div class="safe-box">
    <div class="title">账户保险箱</div>
    <van-form @submit="onSubmit" ref="frm">
      <div style="text-align: left; color: green; margin-bottom: 8px">
        账户额度：{{ safeUsr.balance }}
      </div>
      <div style="text-align: left; color: red; margin-bottom: 8px">
        保险额度：{{ safeUsr.lock_amount }}
      </div>
      <van-field name="radio" label="操作">
        <template #input>
          <van-radio-group v-model="type" direction="horizontal">
            <van-radio name="1">转入</van-radio>
            <van-radio name="2">转出</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="admount"
        label="额度"
        placeholder="操作账户额度"
        :rules="[{ required: true, message: '请填写操作账户额度' }]"
      />
      <van-field
        v-model="pay_pass"
        type="password"
        label="资金密码"
        placeholder="请填写资金密码"
        :rules="[{ required: true, message: '请填写资金密码' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          type == '1' ? '转入' : '转出'
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: 'SafeBoxView',
  props: ['usr'],
  computed: {
    safeUsr () {
      return this.usr || {}
    }
  },
  data () {
    return {
      type: '1',
      admount: null,
      pay_pass: null
    }
  },
  methods: {
    async onSubmit () {
      await this.$http({
        method: 'post',
        url: 'lockAmount',
        data: {
          type: this.type,
          admount: this.admount,
          pay_pass: this.pay_pass
        }
      }).then(data => {
        this.$toast.success(data.msg)
        this.$emit('closep2')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.safe-box {
  margin: 10px;
  padding: 10px;
  width: 80vw;
  .title {
    height: 38px;
    line-height: 38px;
  }
}
</style>
